import { render } from "./SavedSearchesPage.vue?vue&type=template&id=388e857a&scoped=true"
import script from "./SavedSearchesPage.vue?vue&type=script&lang=js"
export * from "./SavedSearchesPage.vue?vue&type=script&lang=js"

import "./SavedSearchesPage.vue?vue&type=style&index=0&id=388e857a&lang=css"
import "./SavedSearchesPage.vue?vue&type=style&index=1&id=388e857a&lang=css"
import "./SavedSearchesPage.vue?vue&type=style&index=2&id=388e857a&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/FLOCKR/FLOCKER-PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-388e857a"]])

export default __exports__